'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const {trackSupportClick, trackBuyerAssuranceClick, trackBuyerAssuranceLinkClick} = require('../../actions/pdpTrackingActions');
const PdpActions = require('../../actions/PdpActions');
const ContextComponent = require('../../../global/components/ContextComponent');
const BuyerAssurance = require('../BuyerAssurance/BuyerAssurance');

class Support extends ContextComponent {
    constructor(props) {
        super(props);

        this._handleSupportClick = this._handleSupportClick.bind(this);
        this._showBuyerAssuranceTooltip = this._showBuyerAssuranceTooltip.bind(this);
        this._hideBuyerAssuranceTooltip = this._hideBuyerAssuranceTooltip.bind(this);
        this._trackBuyerAssuranceLinkClick = this._trackBuyerAssuranceLinkClick.bind(this);
    }

    componentDidMount() {
        // FINDING-7210 - delete buyer assurance "surfaced" cookie
        this.context.executeAction(PdpActions.deleteBuyerAssurance);
    }

    _handleSupportClick() {
        this.context.executeAction(trackSupportClick);
    }

    /*
     * calls PdpAction to show the tooltip
     */
    _showBuyerAssuranceTooltip() {
        this.context.executeAction(trackBuyerAssuranceClick);
        this.context.executeAction(PdpActions.toggleBuyerAssuranceShowInfo, {showInfo: true});
    }

    /**
     * calls PdpAction to hide the tooltip
     * @private
     */
    _hideBuyerAssuranceTooltip() {
        this.context.executeAction(PdpActions.toggleBuyerAssuranceShowInfo, {showInfo: false});
    }

    /**
     * calls PdpTrackingAction to track link clicks
     * @private
     */
    _trackBuyerAssuranceLinkClick() {
        this.context.executeAction(trackBuyerAssuranceLinkClick);
    }

    _renderBuyerAssuranceLink() {
        const props = this.props.buyerAssuranceProps;

        return (
            <BuyerAssurance {...props}
                tradeTour={this.props.tradeTour}
                hideTooltip={this._hideBuyerAssuranceTooltip}
                showTooltip={this._showBuyerAssuranceTooltip}
                trackLinkClick={this._trackBuyerAssuranceLinkClick}
                key='pdp-buyer-assurance-link'/>
        );
    }

    render() {
        // FINDING-7164 : hide buyer assurance when price is hidden
        if (this.props.hidePrice) {
            return null;
        }

        return (
            <div className="pdp-support">
                {this._renderBuyerAssuranceLink()}
            </div>
        );
    }
}

Support.defaultProps = {
    isVariant: false
};

Support.propTypes = {
    isVariant: PropTypes.bool,
    hidePrice: PropTypes.bool,
    buyerAssuranceProps: PropTypes.shape({
        copy: PropTypes.object.isRequired,
        state: PropTypes.shape({
            showInfo: PropTypes.bool.isRequired
        })
    }).isRequired
};

module.exports = Support;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/Support.jsx